import { Input, Select } from "../../../components/ui";
import type {
  EmpresaConfiguracion,
  EmpresaConfiguracionUpdate,
  Segmento,
} from "../api";
import { SaveBar, useConfigForm } from "./_shared";

interface Form {
  segmento: Segmento;
  anio_construccion_sistema: string;
}

const extractor = (cfg: EmpresaConfiguracion): Form => ({
  segmento: cfg.segmento,
  anio_construccion_sistema:
    cfg.anio_construccion_sistema == null
      ? ""
      : String(cfg.anio_construccion_sistema),
});

const parseAnio = (s: string): number | null => {
  const t = s.trim();
  if (t === "") return null;
  const n = Number.parseInt(t, 10);
  return Number.isFinite(n) ? n : null;
};

const differ = (
  f: Form,
  cfg: EmpresaConfiguracion,
): EmpresaConfiguracionUpdate => {
  const out: EmpresaConfiguracionUpdate = {};
  if (f.segmento !== cfg.segmento) out.segmento = f.segmento;
  const anio = parseAnio(f.anio_construccion_sistema);
  if (anio !== cfg.anio_construccion_sistema) out.anio_construccion_sistema = anio;
  return out;
};

export function SissTab({
  cfg,
}: {
  cfg: EmpresaConfiguracion;
}): JSX.Element {
  const { form, setForm, haycambios, pending, reset, save } = useConfigForm(
    cfg,
    extractor,
    differ,
  );

  return (
    <div className="space-y-4 max-w-2xl">
      <p className="text-sm text-neutral-600">
        Clasificación regulatoria del comité según los manuales SISS. El
        segmento determina obligaciones extra de comunicación. El año de
        construcción del sistema fija los rangos admisibles de presión
        (pre-2020: 8–40 mca; 2020+: 15–70 mca).
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Select
          label="Segmento SISS"
          value={form.segmento}
          onChange={(e) =>
            setForm({ ...form, segmento: e.target.value as Segmento })
          }
        >
          <option value="Mayor">Mayor</option>
          <option value="Mediano">Mediano</option>
          <option value="Menor">Menor</option>
        </Select>
        <Input
          label="Año construcción del sistema"
          type="number"
          min={1900}
          max={2100}
          value={form.anio_construccion_sistema}
          onChange={(e) =>
            setForm({ ...form, anio_construccion_sistema: e.target.value })
          }
          placeholder="2018"
        />
      </div>

      <SaveBar
        haycambios={haycambios}
        pending={pending}
        reset={reset}
        save={save}
      />
    </div>
  );
}
